import styled from 'styled-components';
import IconAlarmClockTime from '../../SchedulePage/icons/IconAlarmClockTime';
import Timer from 'react-compound-timer';
import { countRemainPromotion } from './countRemainPromotion';
import * as React from 'react';
import { Typography } from 'components/DesignSystemV2/Typography';
import { colorsV2 } from '../../../style/colors-v2';
import { MONTH_NAME_FORMAT2 } from 'constant';
import moment from 'moment';

export const PromotionInfoWrapper = styled.div`
  text-align: center;
  .scholarship-bonus {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0px;
  }
  .countdown-section {
    margin-top: 4px;
    display: flex;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    color: ${colorsV2.primary100};
    svg {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  .promotion-desc {
    margin-top: 4px;
  }
`;
const PromotionInfo = ({
  value,
  initialTime,
  isPromotionEnded,
  onTimeEnd,
  endDate
}) => {
  return (
    <PromotionInfoWrapper>
      <div className="scholarship-bonus">Ưu đãi lên đến {value}</div>
      <div className="countdown-section">
        {isPromotionEnded ? (
          <>
            <div className="countdown-text">Đã kết thúc</div>
          </>
        ) : (
          <>
            <IconAlarmClockTime />
            <div className="countdown-text">
              <Timer
                initialTime={initialTime}
                direction="backward"
                checkpoints={[
                  {
                    time: 0,
                    callback: onTimeEnd
                  }
                ]}
              >
                {() => (
                  <>
                    Kết thúc sau{' '}
                    <span className="count-down">
                      <Timer.Days />d <Timer.Hours />h <Timer.Minutes />m{' '}
                      <Timer.Seconds />s
                    </span>
                  </>
                )}
              </Timer>
            </div>
          </>
        )}
      </div>
      <Typography
        variant="regular/12-20"
        color={colorsV2.black80}
        className="promotion-desc"
      >
        *Ưu đãi HÈ đăng ký trước {moment(endDate).format(MONTH_NAME_FORMAT2)}
      </Typography>
    </PromotionInfoWrapper>
  );
};
export const GCMSPromotionInfo = ({ promotionByClassGroup }) => {
  const { scholarships, discount, startDate, endDate } = promotionByClassGroup;
  const { remainSlot } = countRemainPromotion({
    remainQuantity: scholarships,
    startDate,
    endDate
  });

  const initialTime = Math.max(
    new Date(endDate).getTime() - new Date().getTime(),
    0
  );
  const [isPromotionEnded, setPromotionEnded] = React.useState(
    remainSlot === 0 || initialTime === 0
  );
  React.useEffect(() => {
    if (!isPromotionEnded) {
      setPromotionEnded(remainSlot === 0 || initialTime === 0);
    }
  }, [initialTime, isPromotionEnded, remainSlot]);

  return (
    <PromotionInfo
      endDate={endDate}
      value={discount}
      initialTime={initialTime}
      isPromotionEnded={isPromotionEnded}
      onTimeEnd={() => setPromotionEnded(true)}
    />
  );
};
